import { useState, useEffect } from 'react';
import { db } from '../../config/FirebaseConfig';
import { collection, getDocs } from 'firebase/firestore';
import { FiTrendingUp, FiImage, FiUsers, FiShoppingCart, FiShare2, FiGrid } from 'react-icons/fi';

const AdminDashboardHome = () => {
  const [stats, setStats] = useState({
    services: 0,
    gallery: 0,
    clients: 0,
    socialMedia: 0,
    ecosystem: 0,
  });

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const servicesSnap = await getDocs(collection(db, 'services'));
        const gallerySnap = await getDocs(collection(db, 'gallery'));
        const clientsSnap = await getDocs(collection(db, 'clients'));
        const socialSnap = await getDocs(collection(db, 'socialMedia'));
        const ecosystemSnap = await getDocs(collection(db, 'ecosystem'));

        setStats({
          services: servicesSnap.size,
          gallery: gallerySnap.size,
          clients: clientsSnap.size,
          socialMedia: socialSnap.size,
          ecosystem: ecosystemSnap.size,
        });
      } catch (error) {
        console.error('Error al obtener estadísticas:', error);
      }
    };

    fetchStats();
  }, []);

  const statCards = [
    {
      label: 'Servicios',
      value: stats.services,
      icon: FiShoppingCart,
      color: 'bg-green-500/20 text-green-600 dark:text-green-400',
      borderColor: 'border-green-500/30',
    },
    {
      label: 'Galerías',
      value: stats.gallery,
      icon: FiImage,
      color: 'bg-purple-500/20 text-purple-600 dark:text-purple-400',
      borderColor: 'border-purple-500/30',
    },
    {
      label: 'Clientes',
      value: stats.clients,
      icon: FiUsers,
      color: 'bg-orange-500/20 text-orange-600 dark:text-orange-400',
      borderColor: 'border-orange-500/30',
    },
    {
      label: 'Redes Sociales',
      value: stats.socialMedia,
      icon: FiShare2,
      color: 'bg-pink-500/20 text-pink-600 dark:text-pink-400',
      borderColor: 'border-pink-500/30',
    },
    {
      label: 'Empresas',
      value: stats.ecosystem,
      icon: FiGrid,
      color: 'bg-indigo-500/20 text-indigo-600 dark:text-indigo-400',
      borderColor: 'border-indigo-500/30',
    },
  ];

  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <h1 className="text-3xl font-bold text-slate-900 dark:text-white">Bienvenido</h1>
        <p className="text-slate-600 dark:text-slate-400">
          Aquí puedes gestionar todo el contenido de tu sitio web
        </p>
      </div>

      {/* Stats Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
        {statCards.map((card) => {
          const Icon = card.icon;
          return (
            <div
              key={card.label}
              className={`${card.color} border-2 ${card.borderColor} p-6 rounded-xl transition-all hover:scale-105`}
            >
              <div className="flex items-start justify-between mb-4">
                <Icon size={32} className="opacity-80" />
                <FiTrendingUp size={20} className="opacity-60" />
              </div>
              <div className="text-3xl font-bold mb-1">{card.value}</div>
              <p className="text-sm opacity-75">{card.label}</p>
            </div>
          );
        })}
      </div>

      {/* Quick Actions */}
      <div className="bg-white dark:bg-slate-800 rounded-xl p-6 border border-slate-200 dark:border-slate-700">
        <h2 className="text-xl font-bold text-slate-900 dark:text-white mb-4">
          Acciones Rápidas
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="p-4 bg-blue-50 dark:bg-blue-950 rounded-lg border border-blue-200 dark:border-blue-800">
            <h3 className="font-semibold text-blue-900 dark:text-blue-200 mb-2">
              📝 Agregar Servicio
            </h3>
            <p className="text-sm text-blue-800 dark:text-blue-300 mb-3">
              Crea nuevos servicios para mostrar en la página
            </p>
            <button className="text-blue-600 dark:text-blue-400 text-sm font-semibold hover:underline">
              Ir →
            </button>
          </div>
          <div className="p-4 bg-purple-50 dark:bg-purple-950 rounded-lg border border-purple-200 dark:border-purple-800">
            <h3 className="font-semibold text-purple-900 dark:text-purple-200 mb-2">
              🖼️ Subir Imágenes
            </h3>
            <p className="text-sm text-purple-800 dark:text-purple-300 mb-3">
              Agrega nuevas imágenes a la galería del portafolio
            </p>
            <button className="text-purple-600 dark:text-purple-400 text-sm font-semibold hover:underline">
              Ir →
            </button>
          </div>
          <div className="p-4 bg-pink-50 dark:bg-pink-950 rounded-lg border border-pink-200 dark:border-pink-800">
            <h3 className="font-semibold text-pink-900 dark:text-pink-200 mb-2">
              📱 Redes Sociales
            </h3>
            <p className="text-sm text-pink-800 dark:text-pink-300 mb-3">
              Configura tus enlaces de redes sociales
            </p>
            <button className="text-pink-600 dark:text-pink-400 text-sm font-semibold hover:underline">
              Ir →
            </button>
          </div>
        </div>
      </div>

      {/* Info Box */}
      <div className="bg-blue-50 dark:bg-blue-950 border border-blue-200 dark:border-blue-800 rounded-xl p-6">
        <h3 className="font-semibold text-blue-900 dark:text-blue-200 mb-2">💡 Tip</h3>
        <p className="text-sm text-blue-800 dark:text-blue-300">
          Todos los cambios que realices aquí se reflejarán automáticamente en tu sitio web.
          Los datos se guardan en tiempo real en la nube.
        </p>
      </div>
    </div>
  );
};

export default AdminDashboardHome;
